module.exports = __webpack_public_path__ + "img/12qygl.af4c8ead.svg";